export function dataInRequest(params = {}) {
  return {
    type: '@empresacliente/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@empresacliente/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@empresacliente/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@empresacliente/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@empresacliente/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@empresacliente/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@empresacliente/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@empresacliente/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@empresacliente/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@empresacliente/RECORD_FILTERING',
    payload: { params },
  };
}
